<h2 class="text-center"> Creating New Message</h2>
<div class="alert alert-info" *ngIf="errorSaving"> Send Message Failed</div>
<form [formGroup]="myForm" (ngSubmit)="submit()">
    <div class="form-group row">
        <label for="to" class="control-label col-sm-2 text-end">To</label>
        <div class="col-sm-8">
            <select class="form-control" id="toUser" formControlName="toUser">
                <option *ngFor="let userOption of toUserOptions" [value]="userOption.id">{{userOption.fullname}}</option>
              </select>
            <div *ngIf="f.toUser.touched && f.toUser.invalid" class="alert alert-danger">
                <div *ngIf="f.toUser.errors.required">Tois required.</div>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <label for="title" class="control-label col-sm-2 text-end">Title</label>
        <div class="col-sm-8">
        <input
            type="text"
            class="form-control"
            id="title"
            formControlName="title">
            <div *ngIf="f.title.touched && f.title.invalid" class="alert alert-danger">
                <div *ngIf="f.title.errors.required">Title is required.</div>
            </div>
        </div>
    </div>

    <div class="form-group row">
        <label for="body" class="control-label col-sm-2 text-end">Body</label>
        <div class="col-sm-8">
            <textarea
                type="text"
                id="body"
                class="form-control"
                formControlName="body"
                rows='10' cols='60'
                ></textarea>
                <div *ngIf="f.body.touched && f.body.invalid" class="alert alert-danger">
                    <div *ngIf="f.body.errors.required">Tois required.</div>
                </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 text-center">
            <button class="btn btn-primary" type="submit">Submit</button>
        </div>
    </div>


</form>
